import { useQuery } from "react-query";
import { getClientBillableUnitsStatus } from "api/customers";
import { STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";

export interface ClientBillableUnitsStatusData {
  client_id: string;
  has_billable_units: boolean;
}

export interface UseClientBillableUnitsStatusOptions {
  clientId: string;
  enabled?: boolean;
}

/**
 * Hook to check if a client has ever had any approved billable units.
 * This is used in the client deactivation dialog to determine whether to show
 * "Drop reason" (no billable units) or "Discharge reason" (has billable units).
 */
export const useClientBillableUnitsStatus = ({
  clientId,
  enabled = true,
}: UseClientBillableUnitsStatusOptions) => {
  return useQuery<ClientBillableUnitsStatusData, Error>(
    ["clientBillableUnitsStatus", clientId],
    async () => {
      if (!clientId) {
        return { client_id: clientId, has_billable_units: false };
      }
      const response = await getClientBillableUnitsStatus(clientId);
      return response.data;
    },
    {
      enabled: enabled && !!clientId,
      staleTime: STALE_TIME_5_MINUTES,
    }
  );
};
